import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { grey } from '@mui/material/colors';
import { Box, Stack, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { DateFormats } from 'constants/common';
import moment from 'moment';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import { CustomerContact, CustomerDetails } from '@trnsact/trnsact-shared-types';

interface Props {
  customerDetails: CustomerDetails;
  customerContacts: CustomerContact[];
}

export const CompanyInformationCard = ({ customerDetails, customerContacts }: Props) => {
  const classes = useStyles();

  return (
    <CardContainer>
      <Stack spacing={1}>
        <Typography variant="h6" component="p">
          {customerDetails.name}
        </Typography>
        <Stack direction="row" gap={1}>
          {customerDetails.phone && (
            <Box className={classes.infoRow}>
              <PhoneIcon sx={{ mr: 0.5 }} />
              <Typography variant="body1">{customerDetails.phone}</Typography>
            </Box>
          )}
          {customerDetails.address && (
            <Box className={classes.infoRow}>
              <LocationOnIcon />
              <Typography variant="body1">{customerDetails.address}</Typography>
            </Box>
          )}
        </Stack>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Contact</TableCell>
              <TableCell>Title</TableCell>
              <TableCell>Phone</TableCell>
              <TableCell>Last Contact</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {customerContacts?.map(contact => (
              <TableRow key={contact.ownerPgId}>
                <TableCell>{[contact.firstName, contact.lastName].filter(Boolean).join(' ')}</TableCell>
                <TableCell>{contact.title}</TableCell>
                <TableCell>{contact.phone}</TableCell>
                <TableCell>{moment(contact.lastContactDate).format(DateFormats.Short)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Stack>
    </CardContainer>
  );
};

const useStyles = makeStyles({
  infoRow: {
    display: 'flex',
    alignItems: 'center',
    color: grey[600],
  },
});
